import React, { useContext, useState, useEffect } from 'react';

import * as Yup from 'yup';
import ReactTable from 'Components/ReactTable/ReactTable';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { UpiTransferWithSender as UPI_TRANSFER } from 'Components/Api/UPITransfer';
import { SELECT_DMT_CHARGE_AND_COMM } from 'Components/utils';
import { TransactionConfirmation } from 'Components/Alert/TransactionConfirmation';
import {
    Select as BENE_SELECT,
    Delete as BENI_DELETE
} from 'Components/Api/UpiBeneficiaryAPI';
import { UPITransferPrint } from 'Components/Print/UPITransferPrint';
import { useHistory } from 'react-router';
import {
    UPITRANSFER_CODE,
    PLEASE_PROVIDE_VALID
} from 'Components/Helper/Messages';
import { BalanceContext } from 'Components/BalanceContext';
import { LOGOUT } from 'ConstComponents';
import { TransactionResponse } from 'Components/Alert/TransactionResponse';
import { SelectDMTForReceiptForWeb as TRANSACTION_RECEIPT } from 'Components/Api/TransactionReportAPI';
import { Select as OPERATOR_SELECT_BY_SERVICEID } from 'Components/Api/OperatorsApi';
var PayoutOperators = [];
export default function UpiBeneficiaryList({
    senderID,
    ActiveUPITransferName,
    senderName,
    senderMobile,
    setIsError,
    setSeverity,
    setLoading,
    setResponseMessage,
    formRef
}) {
    const { DashboardBalanceUpdate } = useContext(BalanceContext);

    const classes = commonStyle();
    const history = useHistory();
    const [mainColumns, setMainColumns] = useState([]);
    const [list, setList] = useState([]);
    const [isResponseAlertOpen, setIsResponseAlertOpen] = useState(false);
    const [isAlertOpen, setIsAlertOpen] = useState(false);
    const [confirmAlertRequest, setConfirmAlertRequest] = useState({});
    const [isPin] = useState(localStorage.getItem('IsPin'));
    const [ResponseAlert, setResponseAlert] = useState({});
    const [serviceCode, setserviceCode] = useState(UPITRANSFER_CODE);

    const [confirmAlertMessage, setConfirmAlertMessage] = useState('');
    const [printData, setPrintData] = useState(null);
    const [Operator, setOperator] = useState([]);
    const [OperatorDefault, setOperatorDefault] = useState({
        OperatorID: 0,
        OperatorName: 'Select Operator'
    });
    const [isPrintOpen, setIsPrintOpen] = useState(false);

    const [FormObj, setFormObj] = useState({
        ServiceID: UPITRANSFER_CODE,
        Operator: OperatorDefault,
        Amount: '',
        InWords: '',
        UpiID: '',
        BeneName: '',
        IsVerifyButton: false,
        PaymentType: ''
    });

    useEffect(() => {
        createColumns();
        select();
    }, [senderID, senderMobile]);

    const select = async () => {
        setList([]);
        setLoading(true);
        setIsError(false);
        if (senderID === undefined) return;

        if (senderID === '') return;

        var beneReqObj = JSON.stringify({
            UpiSenderID: senderID,
            ActiveUPITransferName: ActiveUPITransferName
        });

        setLoading(false);
        setList([]);
        var response = await BENE_SELECT(beneReqObj);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage(response.data);
            return;
        }

        var data = JSON.parse(response.data);

        if (data.length < 0) {
            setSeverity('error');
            setIsError(true);
            setResponseMessage('No Beneficiary Found');
            return;
        }

        setList(data);
    };

    useEffect(() => {
        setLoading(true);
        selectOperator(serviceCode);
    }, [serviceCode]);

    const selectOperator = async (ServiceID) => {
        if (
            ServiceID === null ||
            ServiceID === undefined ||
            ServiceID === 0 ||
            ServiceID === '0'
        )
            return;

        var requestObj = {
            ServiceID: ServiceID
        };

        var request = JSON.stringify(requestObj);

        const response = await OPERATOR_SELECT_BY_SERVICEID(request);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) setIsError(true);

        if (response.data === 'Requested operators not found') {
            setIsError(true);
            return;
        }

        var data = JSON.parse(response.data);

        const optionsProviders = data.map(function (row) {
            return { ID: row.OperatorID, Type: row.OperatorName };
        });

        PayoutOperators = optionsProviders;
        createColumns();

        setOperator(data);
    };

    const Print = (VendorID) => {
        SelectPrintData(VendorID);
    };

    const SelectPrintData = async (TransactionMasterID) => {
        var req = {
            ID: TransactionMasterID
        };
        var request = JSON.stringify(req);
        setLoading(true);
        const { isAuthorized, status, data } = await TRANSACTION_RECEIPT(
            request
        );
        setLoading(false);
        if (!isAuthorized) LOGOUT();
        var d = JSON.parse(data);
        setPrintData(d);
        setIsPrintOpen(true);
    };

    const createColumns = () => {
        var columns = [];

        columns.push({
            label: '#',
            name: 'UpiBeneficiaryID',
            srno: true
        });

        columns.push({
            label: 'Name',
            name: 'Name',
            bold: true
        });

        columns.push({
            label: 'UpiID',
            name: 'UpiID',
            bold: true
        });

        columns.push({
            label: 'Operator',
            name: 'OperatorID',
            dropdown: true,
            list: PayoutOperators
        });

        columns.push({
            label: 'Amount',
            name: 'Amount',
            length: 6,
            editableWithNumberOnly: true
        });
        if (isPin === 'true') {
            columns.push({
                label: 'Pin',
                name: 'RechargePin',
                editableWithPinOnly: true,
                length: 4
            });
        }
        columns.push({
            label: 'Verified',
            name: 'IsVerified',
            buttonTitle: 'Verify',
            buttonOrLabel: true,
            callback: (values) => {
                VerifyConfirmation(values);
            }
        });
        columns.push({
            label: 'Transfer',
            name: 'UpiBeneficiaryID',
            transfer: true,
            buttonTitle: 'Transfer',
            callback: (value) => {
                TransferConfirmation(value);
            }
        });

        columns.push({
            label: 'Delete',
            name: 'UpiBeneficiaryID',
            icon: 'DeleteIcon',
            iconButtonWithRow: true,
            callback: (value) => {
                Delete(value);
            }
        });
        columns.push({
            label: 'UpiSenderID',
            name: 'UpiSenderID',
            hide: true
        });

        columns.push({
            label: 'BeneficiaryID',
            name: 'BeneficiaryID',
            hide: true
        });
        setMainColumns(columns);
    };

    const VerifyConfirmation = async (values) => {
        let jsonObj = {
            UpiBeneficiaryID: values[0],
            BeneName: values[1],
            UpiID: values[2],
            Amount: values[4],
            UpiSenderID: values[8],
            OperatorID: values[3],
            ServiceID: UPITRANSFER_CODE,
            IsPin: isPin,
            IsVerify: false,
            PaymentType: ''
        };

        setConfirmAlertRequest(jsonObj);

        setIsError(false);
        var errorValidation = false;

        await TransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);
            //selectSuccessUPITransaction();
            return;
        });

        if (errorValidation === true) return;

        let msg = `Please confirm UPI details - \n\n UPI ID : ${values[2]}\nAmount : ${values[4]}`;

        setConfirmAlertMessage(msg);
        setIsAlertOpen(true);
    };

    const TransferValidation = Yup.object({
        BeneName: Yup.string().required(PLEASE_PROVIDE_VALID + 'name'),
        UpiBeneficiaryID: Yup.string().required(PLEASE_PROVIDE_VALID + 'bene'),
        UpiSenderID: Yup.string().required(PLEASE_PROVIDE_VALID + 'sender'),
        Amount: Yup.number()
            .required(PLEASE_PROVIDE_VALID + 'amount')
            .min(1, PLEASE_PROVIDE_VALID + 'amount')
    });

    const UPITransfer = async () => {
        setResponseMessage('');
        setIsError(false);

        confirmAlertRequest.ActiveUPI = ActiveUPITransferName;
        confirmAlertRequest.Mobile = senderMobile;
        var requestObj = JSON.stringify(confirmAlertRequest);
        setLoading(true);

        let response = '';

        response = await UPI_TRANSFER(requestObj);

        setLoading(false);

        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            let data = JSON.parse(response.data);
            setResponseMessage(data.Message);
            setIsError(true);
            return;
        }

        let dataSuccess = JSON.parse(response.data);

        setSeverity('success');
        setResponseMessage(dataSuccess.Message);
        //setStatus(dataSuccess.Status);
        setResponseAlert(dataSuccess);
        setIsResponseAlertOpen(true);
        //selectSuccessUPITransaction();
        reset(
            dataSuccess.BeneficiaryName,
            confirmAlertRequest.IsVerify,
            confirmAlertRequest.UpiID,
            confirmAlertRequest.PaymentType,
            confirmAlertRequest.OperatorID
        );
    };

    const reset = (
        BeneficiaryName,
        IsVerify,
        UpiID,
        PaymentType,
        OperatorID
    ) => {
        if (IsVerify === true) {
            setOperatorDefault({
                OperatorID: OperatorID,
                OperatorName: PaymentType
            });
            setFormObj({
                ...FormObj,
                UpiID: UpiID,
                BeneName: BeneficiaryName,
                Operator: OperatorDefault
            });
        }

        if (IsVerify === false) {
            setFormObj({
                ServiceID: UPITRANSFER_CODE,
                Operator: OperatorDefault,
                Amount: '',
                UpiID: '',
                InWords: '',
                BeneName: BeneficiaryName,
                IsVerifyButton: false
            });
        }
    };

    const TransferConfirmation = async (values) => {
        setConfirmAlertRequest({});
        setLoading(true);
        var requestObj = {
            ActiveUPITransferName: ActiveUPITransferName,
            Amount: values[4]
        };
        const { Commission, Charge, Total } = await SELECT_DMT_CHARGE_AND_COMM(
            requestObj
        );
        setLoading(false);

        let UpiSenderID = values[8];
        let UpiBeneficiaryID = values[0];
        let RechargePin = values[6];

        if (isPin !== 'true') {
            UpiSenderID = values[7];
            RechargePin = '';
        }
        let jsonObj = {
            UpiBeneficiaryID: UpiBeneficiaryID,
            BeneName: values[1],
            UpiID: values[2],
            Amount: values[4],
            RechargePin: RechargePin,
            UpiSenderID: UpiSenderID,
            OperatorID: values[3],
            ServiceID: UPITRANSFER_CODE,
            IsPin: isPin,
            IsVerify: false,
            PaymentType: '',
            Mobile: senderMobile
        };
        setIsError(false);
        var errorValidation = false;

        await TransferValidation.validate(jsonObj).catch(function (err) {
            errorValidation = true;
            setSeverity('error');
            setResponseMessage(err.message);
            setIsError(true);

            select();
            return;
        });

        if (errorValidation === true) return;

        setIsAlertOpen(true);
        setConfirmAlertRequest(jsonObj);
    };

    const Delete = async (values) => {
        let UpiSenderID = values[7];
        if (isPin !== 'true') {
            UpiSenderID = values[8];
        }
        var request = {
            UpiBeneficiaryID: values[0],
            UpiSenderID: UpiSenderID,
            ActiveUPITransferName: ActiveUPITransferName
        };
        setLoading(true);
        setIsError(false);

        var requestObj = JSON.stringify(request);

        var response = await BENI_DELETE(requestObj);

        setLoading(false);
        if (!response.isAuthorized) LOGOUT();
        setIsError(true);
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            select();
            return;
        }
        select();
        setSeverity('success');
        if (formRef.current) formRef.current.handleSubmit();
    };

    const sendCallback = (data) => {
        setIsResponseAlertOpen(false);
        setSeverity('success');
        if (data.Status === 'FAILURE') {
            setSeverity('error');
        }
        select();
        var param = {
            Mobile: data.Mobile,
            DMTName: ActiveUPITransferName
        };
        history.push('/C_SenderSearch', param);
    };

    if (
        senderMobile === undefined ||
        senderMobile === null ||
        senderMobile.length <= 5
    ) {
        return null;
    }

    return (
        <>
            <h2 className={classes.PaperHead_h2}>Beneficiary List</h2>
            <ReactTable data={list} columns={mainColumns} rowsPerPage={100} />
            {isAlertOpen ? (
                <TransactionConfirmation
                    isOpen={isAlertOpen}
                    title="UPI Transfer Confirmation"
                    message="Are you sure to do this transaction?"
                    request={confirmAlertRequest}
                    positiveButtonClick={(request) => {
                        setIsAlertOpen(false);
                        UPITransfer(request);
                    }}
                    negativeButtonClick={() => {
                        setIsAlertOpen(false);
                    }}
                />
            ) : null}

            {isResponseAlertOpen ? (
                <TransactionResponse
                    isOpen={isResponseAlertOpen}
                    isPrint={true}
                    title={ResponseAlert.Status}
                    ServiceID={serviceCode}
                    request={ResponseAlert}
                    OkButtonClick={(request) => {
                        setIsResponseAlertOpen(false);
                    }}
                    PrintButtonClick={() => {
                        Print(ResponseAlert.VendorID);
                        setIsResponseAlertOpen(false);
                    }}
                />
            ) : null}

            {isPrintOpen ? (
                <UPITransferPrint
                    isOpen={isPrintOpen}
                    title="UPI Transfer Print"
                    request={printData}
                    positiveButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                    negativeButtonClick={() => {
                        setIsPrintOpen(false);
                    }}
                />
            ) : null}
        </>
    );
}
